<template>
    <div class="box my-2">
        <h2 v-if="title">{{title}}</h2>

        <b-container v-if="showFilter" fluid class="px-0 mb-3">
            <!-- User Interface controls -->
            <b-row>
                <b-col lg="6">
                    <b-input-group size="sm">
                        <b-form-input
                            v-model="filter"
                            type="search"
                            debounce="500"
                            placeholder="Rechercher..."
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-container>

        <b-table 
            id="offers-list"
            :busy.sync="isBusy"
            :items="offersForToday"
            :fields="fields"
            primary-key="id"
            :tbody-tr-class="rowClass"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            small
            responsive="sm"
            show-empty
            empty-text="Aucune commande"
            empty-filtered-text="Aucune commande ne correspond au texte recherché"
        >
            <template v-slot:cell(id)="data">
                <b-link v-bind:href="'/offer/' + data.item.id + '/show'">{{ data.item.id }}</b-link>                
            </template>

            <template v-slot:cell(customerLastname)="data">
                <b-link v-bind:href="'/customer/' + data.item.customer_id + '/show'">{{ data.item.customer_lastname }}</b-link>                
            </template>

            <template v-slot:cell(deliveryDate)="data">
                {{data.item.delivery_date | mysqlDateToFull}}               
            </template>

            <template v-slot:cell(offerStatus)="data">
                {{data.value}}               
            </template>

            <template v-slot:cell(price)="data">
                {{Number(data.item.price).toFixed(2)}} Eur
            </template>

            <template v-slot:cell(paid)="data">
                <b-icon-check v-if="data.item.paid" font-scale="1.4" class="border rounded" variant="success"></b-icon-check>
            </template>
        </b-table>

        <b-pagination
            v-show="rows > perPage"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="offers-list"
        ></b-pagination>
    </div>
</template>

<script>
    export default {
        props: {
            title: {default: null, type: String},
            perPage: {default: 20, type: Number},
            initialSortBy: {default: 'id', type: String},
            initialSortDesc: {default: false, type: Boolean},
            minOfferstatusId: {default: null, type: Number},
            maxOfferstatusId: {default: null, type: Number},
            cancelledOnly: {default: false, type: Boolean},
            includeCancelled: {default: false, type: Boolean},
            unpaidOnly: {default: false, type: Boolean},
            days: {defaut: null, type: Number},
            showFilter: {default: false, type: Boolean},
            showStatus: {default: false, type: Boolean},
            showPrice: {default: false, type: Boolean},
            showPaidFlag: {default: false, type: Boolean}
        },
        data() {
            return {
                isBusy: false,
                filter: null,
                items: [],
                currentPage: 1,
                rows: null,
                fields: [],
                sortBy: this.initialSortBy,
                sortDesc: this.initialSortDesc
            }
        },
        created() {
            this.fields = [
                    { key: 'id', label: 'Référence', sortable: true },
                    { key: 'customerLastname', label: 'Client',  sortable: true },
                    { key: 'name', label: 'Titre', sortable: true },
                    { key: 'deliveryDate', label: 'Date de livraison', sortable: true }
            ];
            if(this.showStatus){
                this.fields.push({ key: 'offerStatus', label: 'Statut', sortable: true, formatter: 'fullStatus'});
            }
            if(this.showPrice){
                this.fields.push({ key: 'price', label: 'Montant total', class: 'text-right', sortable: true});
            }
            if(this.showPaidFlag){
                this.fields.push({ key: 'paid', label: 'Réglée', class: 'text-center', sortable: true});
            }
        },
        methods: {
            offersForToday(ctx) {
                let options = {
                    minOfferstatusId: this.minOfferstatusId,
                    maxOfferstatusId: this.maxOfferstatusId,
                    cancelledOnly: this.cancelledOnly,
                    includeCancelled: this.includeCancelled,
                    unpaidOnly: this.unpaidOnly,
                    days: this.days
                };
                options = Object.assign({},ctx, options);
                let promise = window.axios.post('/offer/offersList', {options: options});
                return promise.then((response) => {
                    this.items = response.data.offers;
                    this.rows = response.data.rows;
                    return(this.items);
                }).catch(error => {
                    return []
                });
            },
            fullStatus(value, key, item) {
                if(item.cancelled){
                    return 'Annulée';
                }else{
                    return item.offerstatus_name;
                }
            },
            rowClass(item, type) {
                if (!item || type !== 'row') {
                    return;
                }
                if (item.cancelled) {
                    return 'cancelled';
                }
            }
        },
        filters: {
            mysqlDateToFull: function (value) {
                if (!value) return '';
                return mysqlDateToFull(value);
            }
        }
    }
</script>